import { t } from "@/i18n-js/instance";
import { isAnnual, isMonthly } from "@/react/helpers/planHelpers";
import { Typography } from "@circle-react-uikit/Typography";
import { usePlans } from "../../../RegularPlan/PlansContext";

const localeRoot = "pricing_plans.plan_settings.plan_summary";

export const PlanPrice = () => {
  const { selectedPlan } = usePlans();
  if (!selectedPlan) return null;

  return (
    <div className="flex flex-row gap-1">
      {isAnnual(selectedPlan.interval) && (
        <>
          <Typography.BodyXs textTransform="line-through" color="text-default">
            {selectedPlan.strike_through_price}
          </Typography.BodyXs>
          <Typography.BodyXs color="text-default">
            {t([localeRoot, "plan_annual_amount"], {
              amount: selectedPlan.display_base_monthly_amount,
            })}
          </Typography.BodyXs>
        </>
      )}
      {isMonthly(selectedPlan.interval) && (
        <Typography.BodyXs color="text-default">
          {t([localeRoot, "plan_monthly_amount"], {
            amount: selectedPlan.display_base_monthly_amount,
          })}
        </Typography.BodyXs>
      )}
    </div>
  );
};
